import { cn } from "@newxsystems/shared";
import { StratosCardLink } from "../StratosCardLink/StratosCardLink";
import { StratosMedia } from "../StratosMedia/StratosMedia";
import { StratosRichText } from "../StratosRichText/StratosRichText";
import type { IImageContentGridBottomProps } from "./ImageContentGridBottom.props";

const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;

export const ImageContentGridBottom = ({
  columnCount,
  imageAspectRatio,
  items,
}: IImageContentGridBottomProps) => (
  <div className={cn("grid grid-cols-1 gap-4 sm:grid-cols-2", columns[columnCount || 3])}>
    {items.map((item, index) => (
      <StratosCardLink
        className="flex flex-col overflow-hidden rounded-[20px] border-0 bg-mist"
        key={index}
        link={item.cardLink}
      >
        <div className="flex-1 p-7 md:p-9">
          <h3 className="font-stratos-display text-3xl font-bold leading-tight transition-colors group-hover:text-primary">
            {item.heading}
          </h3>
          {item.description ? (
            <StratosRichText
              className="mt-4 text-base text-steel md:text-lg"
              content={item.description}
            />
          ) : null}
        </div>
        <StratosMedia
          aspectRatio={imageAspectRatio || "16:9"}
          media={item.image.image}
          sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
        />
      </StratosCardLink>
    ))}
  </div>
);

ImageContentGridBottom.displayName = "Content::ImageContentGridBottom";
